<template>
    <Panel id="dashboard-wrapper">
        <template #header>
            <h3>Dashboard: {{ stek?.name }}</h3>
        </template>
        <template #icons>
            <div v-if="!isEditing" style="display: flex">
                <Button
                    class="p-button-secondary p-button-rounded theme-change"
                    icon="pi pi-lock"
                    @click="isEditing = true"
                />
            </div>
            <div v-else>
                <Button
                    v-show="!showWidgetToolbar"
                    class="p-button-secondary p-button-rounded theme-change"
                    icon="pi pi-wrench"
                    @click="showWidgetToolbar = true"
                />
                <Button
                    class="p-button-secondary p-button-rounded theme-change"
                    icon="pi pi-lock-open"
                    @click="stopEditing()"
                />
            </div>
        </template>
        <c-dashboard
            ref="dashboard"
            :data-edit="isEditing ? true : undefined"
            :data-show-widget-toolbar="showWidgetToolbar ? true : undefined"
        ></c-dashboard>
    </Panel>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useStekManager } from "@/composables/stek-manager";
import "@/wc/dashboard/index";
const { stek } = useStekManager();

const dashboard = ref(null);
const isEditing = ref(false);
const showWidgetToolbar = ref(false);

function stopEditing() {
    dashboard.value.save();
    isEditing.value = false;
    showWidgetToolbar.value = false;
}
</script>

<style lang="css">
#dashboard-wrapper {
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    margin: 1rem;
}

.p-panel-content {
    padding: 0 !important;
}
</style>
